import { render, staticRenderFns } from "./contactDialog.vue?vue&type=template&id=947c5154&scoped=true"
import script from "./contactDialog.vue?vue&type=script&lang=js"
export * from "./contactDialog.vue?vue&type=script&lang=js"
import style0 from "./contactDialog.vue?vue&type=style&index=0&id=947c5154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947c5154",
  null
  
)

export default component.exports